import { render, staticRenderFns } from "./ContainerTrailers.vue?vue&type=template&id=791a7439&scoped=true&"
import script from "./ContainerTrailers.vue?vue&type=script&lang=js&"
export * from "./ContainerTrailers.vue?vue&type=script&lang=js&"
import style0 from "./ContainerTrailers.vue?vue&type=style&index=0&id=791a7439&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791a7439",
  null
  
)

export default component.exports